import {Grid} from '@material-ui/core'
import {_} from 'i18n'
import React from 'react'

import {ContainerHeader, DetailContainer, Paper} from '../styles'

var groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    ;(rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}

const CityAttachments = ({multimedia}) => {
  if (!multimedia) {
    return (
      <Paper>
        <ContainerHeader>{_`Arquivos Sobre o Município`}</ContainerHeader>
        <DetailContainer>
          <h3>{_`Informação não preenchida pelo Município`}</h3>
        </DetailContainer>
      </Paper>
    )
  }

  const grouped = groupBy(multimedia, 'type')

  return (
    <Paper>
      <ContainerHeader>{_`Arquivos Sobre o Município`}</ContainerHeader>
      <DetailContainer>
        <Grid container>
          <Grid item lg={4}>
            {grouped['image'] ? (
              <div>
                <span className="secundary-title">{_`Fotos`}</span>
                <br />
                <br />
                <ul className="image-files" style={{display: 'flex'}}>
                  {grouped['image'].map((file, index) => (
                    <a href={file.path} target="_blank" rel="noopener noreferrer" key={`image-${file.path}-${index}`}>
                      <li style={{backgroundImage: `url(${file.path})`, backgroundSize: 'cover', marginRight: 10}}></li>
                    </a>
                  ))}
                </ul>
              </div>
            ) : null}
          </Grid>
          <Grid item lg={4}>
            {grouped['document'] ? (
              <div>
                <span className="secundary-title">{_`Documentos`}</span>
                <br />
                <br />
                <ul className="image-files" style={{display: 'flex'}}>
                  {grouped['document'].map((file, index) => (
                    <a
                      href={file.path}
                      target="_blank"
                      rel="noopener noreferrer"
                      key={`document-${file.path}-${index}`}>
                      <li
                        style={{
                          backgroundImage: 'url(https://i.imgur.com/ZmTELra.png)',
                          backgroundSize: 'cover',
                          marginRight: 10,
                        }}></li>
                    </a>
                  ))}
                </ul>
              </div>
            ) : null}
          </Grid>
          <Grid item lg={4}>
            {grouped['video'] ? (
              <div>
                <span className="secundary-title">{_`Vídeos`}</span>
                <br />
                <br />
                <ul className="image-files" style={{display: 'flex'}}>
                  {grouped['video'].map((file, index) => (
                    <a href={file.path} target="_blank" rel="noopener noreferrer" key={`video-${file.path}-${index}`}>
                      <li
                        style={{
                          backgroundImage: 'url(https://i.imgur.com/ZmTELra.png)',
                          backgroundSize: 'cover',
                          marginRight: 10,
                        }}></li>
                    </a>
                  ))}
                </ul>
              </div>
            ) : null}
          </Grid>
        </Grid>
      </DetailContainer>
    </Paper>
  )
}

export default CityAttachments
